import { useId } from "react";

import { type PanelProps } from "ui/panel/panel.types";

type UsePanelProps = Pick<PanelProps, "title" | "subtitle" | "onClose" | "action">;

export const usePanel = ({ title, subtitle, onClose, action }: UsePanelProps) => {
  const titleId = useId();
  const hasTitle = Boolean(title);
  const hasAction = Boolean(action);
  const hasClose = !hasAction && Boolean(onClose);
  const hasCorner = hasAction || hasClose;

  return {
    hasHeader: hasTitle || Boolean(subtitle) || hasCorner,
    hasAction,
    hasClose,
    hasCorner,
    /** Only a rendered title can name the `section`. */
    titleId: hasTitle ? titleId : undefined,
  };
};
